export function initHomepageInfo() {
  const topMetaRow = document.getElementById('top-meta-row')
  const sessionIdEl = document.getElementById('session-id-value')
  const SESSION_ID_KEY = 'ouie.session-id'

  if (!topMetaRow || !sessionIdEl) return

  function generateHash(): string {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
    const random = crypto.getRandomValues(new Uint8Array(10))

    return Array.from(random)
      .map((value) => chars[value % chars.length])
      .join('')
  }

  function getOrCreateSessionId(): string {
    try {
      const existing = window.localStorage.getItem(SESSION_ID_KEY)

      if (existing && existing.length === 10) return existing

      const nextId = generateHash()

      window.localStorage.setItem(SESSION_ID_KEY, nextId)

      return nextId
    }
    catch {
      // If storage is blocked, still provide a deterministic length fallback.
      return generateHash()
    }
  }

  function isProductPage(pathname: string): boolean {
    return pathname.startsWith('/products/') || pathname.includes('/products/')
  }

  function isCollectionPage(pathname: string): boolean {
    return (pathname === '/collections' || pathname.startsWith('/collections/')) && !isProductPage(pathname)
  }

  function isPage(pathname: string): boolean {
    return pathname === '/pages' || pathname.startsWith('/pages/')
  }

  function isCartPage(pathname: string): boolean {
    return pathname === '/cart' || pathname.startsWith('/cart/')
  }

  function updateVisibility(): void {
    const pathname = window.location.pathname
    const show = isCollectionPage(pathname) || isPage(pathname) || isCartPage(pathname)

    topMetaRow.style.display = show ? '' : 'none'
  }

  // Initial visibility
  updateVisibility()

  // Reuse the same ID for this browser/user across refreshes.
  sessionIdEl.textContent = getOrCreateSessionId()

  // Handle Taxi navigation - use navigateIn for immediate visibility update
  window.addEventListener('taxi.navigateIn', () => {
    updateVisibility()
  })
}
